import { useMemo } from "react"
import { omit } from "lib/helpers"
import { useApiData } from "./useApiData"

export type TaskType = `profile` | `account` | `product` | `stock`

export interface Task {
  description: string
  descriptionCompleted: string
  type: TaskType
  redirectUrl: string
  isComplete: boolean
}

export interface OnboardingTasksResponse {
  tasks: Task[]
  areRequiredTasksComplete: boolean
}

function useOnboardingTasks() {
  const response = useApiData<OnboardingTasksResponse>(
    `brands/tasks/onboarding`
  )

  return useMemo(
    () => ({
      ...omit(response, `data`),
      tasks: response.data?.tasks,
      completed: response.data?.areRequiredTasksComplete
    }),
    [response]
  )
}

export default useOnboardingTasks
